import * as React from 'react';
import { FC } from 'react';
import { makeStyles, createStyles } from '@material-ui/styles';
import stylesheet from 'src/constants/stylesheet';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
        },
        subtitle: {
            ...stylesheet.TitleH1,
        },
        caption: {},
    }));

export type PanelSubTitleProps = PanelSubTitleDto;
type Props = PanelSubTitleProps;

const PanelSubTitle: FC<Props> = ({ Subtitle, Caption }) => {
    const cls = useStyles();

    return (
        <div className={cls.root}>
            <h2 className={cls.subtitle}>{Subtitle}</h2>
            <div className={cls.caption}>{Caption}</div>
        </div>
    );
}

export default PanelSubTitle;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelSubTitle.tsx